import { createAsyncThunk } from '@reduxjs/toolkit';
import { DateTime } from 'luxon';

export const setMonthUseCase = createAsyncThunk(
  'setMonthUseCase',
  async (
    data: { month: number },
    { dispatch, extra, getState }: { dispatch: any; extra: any; getState: any }
  ) => {
    let { year } = getState().archives.suiviInstruction;

    if (!year) {
      const today = DateTime.local();
      year = today.month;
    }

    return {
      month: data.month,
      year: year,
    };
  }
);

export default setMonthUseCase;
